import React from 'react'
import { useParams } from 'react-router-dom'
import { useRedirectTo } from '@@partner:helpers/hooks/location'

import { Panel } from 'rsuite'
import LabelsForm from '@components/marketing/labels/LabelsForm'

import { ROUTE_MARKETING_LABELS } from '@@partner:config/routes'

export default function LabelFormPage () {
  const { labelId, brandSlug } = useParams<any>()
  const redirectToCatalog = useRedirectTo(ROUTE_MARKETING_LABELS, {
    brandSlug
  })

  return (
    <div className="LabelFormPage">
      <h1 className="u-heading">{labelId ? 'Редактирование' : 'Добавление'}</h1>
      
      <LabelsForm labelId={labelId} onSaved={redirectToCatalog} />
    </div>
  )
}
